'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:MainController
 * @description
 * # MainController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('MainController', ['$rootScope', '$scope', '$location', '$window', '$timeout', '$routeParams', 'FlashService', 'UserInfo', 'MainMenu', 'LocationHelperService', 'BrowserTab', 'Constants', 'CommonHelper','TokenInterceptor',
      function ($rootScope, $scope, $location, $window, $timeout, $routeParams, FlashService, UserInfo, MainMenu, LocationHelperService, BrowserTab, Constants, CommonHelper, TokenInterceptor) {

        var doNotChangeOnResize = false;

        $scope.getMenuItemIcon = function (type) {
            return MainMenu.GetIcon(type);
        };

        $scope.defaultMenuAction = function (item) {
            MainMenu.Navigate(item, $scope.userInfo.selectedApp.id);
        };

        $scope.setupMenuAction = function (item) {
            $location.path('/grid/{0}/{1}/{2}'.format(item.type, $routeParams.id, item.id));
        };

        $scope.openNewTab = function (event, item) {

            event.stopPropagation();

            var path = $location.path().split('/');
            var absUrl = $location.absUrl().split('/');
            var url = $location.absUrl().split('/')[0];

            url = LocationHelperService.ProcessBranchName(url, absUrl);

            if (item.displayType) {
                var newTab = $window.open(url, '_blank');

                if (item.displayType === 'preview') {
                    url = '{0}/{1}/{2}'.format(url, item.displayType, item.id);
                    newTab.location.href = url;
                }
                else {
                    var loading = FlashService.Loading();
                    MainMenu.GetFirstSetupMenuItem($scope.userInfo.selectedApp.id, item.id).then(function (menuItem) {
                        url = '{0}/{1}/{2}/{3}/{4}'.format(url, item.displayType, menuItem.type, item.id, menuItem.id);
                        loading.dismiss();
                        newTab.location.href = url;
                    });
                }
            } else {
                url = '{0}/{1}/{2}/{3}/{4}'.format(url, path[1], item.type, $routeParams.id, item.id);
                $window.open(url, '_blank');
            }
        };

        $scope.showItem = function (item) {
            return !item.isTile || $location.path() !== '/home';
        };

        $scope.getTodayAssignmentsTitle = function () {
            return $rootScope.todayAssignmentsTitle;
        };

        $scope.getCurrentDate = function () {
            return moment().format('MMMM D, YYYY');
        };

        $scope.getScheduleDate = function () {
            //dateCycle is set to null temporarily, need to get data from server. Now getting dateCycle from Constants
            var dateString = moment($rootScope.scheduleDate).format('MMMM D, YYYY') + ' (Week ' + CommonHelper.Dates.GetWeeklyCycleWeekNumberChar($rootScope.scheduleDate, null) + ')';

            return dateString;

            //return moment().format('MMMM D, YYYY');
        };
        
        $scope.setNewSchdeduleDate = function (previousOrNext) {
            switch (previousOrNext) {
                case 'previous':
                    //console.log(previousOrNext);
                    $rootScope.scheduleDate = moment($rootScope.scheduleDate).subtract(1, 'days');
        
                    break;
                case 'next':
                    //console.log(previousOrNext);
                    $rootScope.scheduleDate = moment($rootScope.scheduleDate).add(1, 'days');
        
                    break;
                default:
                    //console.log('Something went wrong');
        
                    break;
            }
        
            $rootScope.getScheduleData($rootScope.scheduleDate);
        };

        $scope.isActiveDefaultItem = function (item) {
            if (item.displayType === 'page') {
                return parseInt($routeParams.id) === item.htmlPageId;
            }

            if ($routeParams.id) {
                return parseInt($routeParams.id) === item.id;
            }

            return $location.path().split('/')[1] === item || $location.path().split('/')[1] === item.displayType;
        };

        $scope.isActiveSetupItem = function (item) {
            return parseInt($routeParams.grid) === item.id;
        };

        function changeApplication () {
            var loading = FlashService.Loading();

            $scope.applicationChanging = true;
            $scope.menuLoaded = false;
            $location.path('home');
            MainMenu.GetMenu($rootScope.globals.application.id).then(function (menu) {
                $scope.menu = menu;
                $timeout(function () {
                    loading.dismiss();
                    $scope.applicationChanging = false;
                    $scope.menuLoaded = true;
                    initMenu();
                }, 10);

            });
        }

        function switchSite ($event, id) {
            clearDailyPlanSearchParams();

            $scope.applicationChanging = true;
            $location.path('home');
            $scope.menuLoaded = false;
            UserInfo.SwitchSite(id).then(function (user) {
                $scope.userInfo = user.userInfo;
                $scope.menu = user.menu;
                $timeout(function () {
                    $scope.applicationChanging = false;
                    $scope.menuLoaded = true;
                    $rootScope.$broadcast('reloadHeader');
                }, 10);
            });

            $event.preventDefault();
        }

        function switchRole ($event, id) {
            $scope.applicationChanging = true;
            $location.path('home');
            $scope.menuLoaded = false;
            UserInfo.SwitchRole(id).then(function (user) {
            $scope.userInfo = user.userInfo;
            $scope.menu = user.menu;
                $timeout(function () {
                    $scope.applicationChanging = false;
                    $scope.menuLoaded = true;
                    $rootScope.$broadcast('reloadHeader');
                }, 10);
            });

            $event.preventDefault();
        }

        function switchGroup ($event, id) {
            $scope.applicationChanging = true;
            UserInfo.SwitchGroup(id).then(function (user) {
                $scope.userInfo = user;
                $timeout(function () {
                    $scope.applicationChanging = false;
                    $rootScope.$broadcast('reloadHeader');
                }, 10);
            });
            $event.preventDefault();
        }

        function clearDailyPlanSearchParams() {
            $location.search('type', null);
            $location.search('id', null);
            $location.search('room', null);
            $location.search('facility', null);
        }

          function getUserRoles() {

              return $scope.userInfo.roles.map(function (role) {
                  return role.name;
              });
          }

          function getPendoMetadata() {

              return {
                  visitor: {
                      id: $scope.userInfo.userId,
                      email: $scope.userInfo.email,
                      roles: getUserRoles()
                  },
                  account: {
                      id: window.location.hostname,
                      product: 'Resource Scheduling'
                  }
              }
          }

        function getApplicationOption() {

            if (!MainMenu.applicationOptions && MainMenu.setupMenu) {
                return MainMenu.setupMenu;
            }

            if (!MainMenu.applicationOptions) {
                return;
            }

            var displayType = $location.path().split('/')[1];
            var sectionOptions = [];

            switch (displayType) {
                case ('page'):
                    var htmlPageId = +$location.path().split('/')[2];
                    Object.keys(MainMenu.applicationOptions.sections).forEach(key => sectionOptions = sectionOptions.concat(MainMenu.applicationOptions.sections[key].options));
                    return sectionOptions.find(item =>  item.displayType === displayType && item.htmlPageId === htmlPageId);
                case ('reports'):
                case ('calendar'):
                case ('dashboard'):
                    var id = +$location.path().split('/')[2];
                    Object.keys(MainMenu.applicationOptions.sections).forEach(key => sectionOptions = sectionOptions.concat(MainMenu.applicationOptions.sections[key].options));
                    return sectionOptions.find(item =>  item.displayType === displayType && item.id === id);
                case ('grid'):
                    var gridId = +$location.path().split('/')[3];
                    Object.keys(MainMenu.applicationOptions.sections).forEach(key => sectionOptions = sectionOptions.concat(MainMenu.applicationOptions.sections[key].options));
                    return sectionOptions.find(item =>  item.displayType === displayType && item.id === gridId);
                case ('home'):
                    return MainMenu.applicationOptions.sections.home;
                default:
                    Object.keys(MainMenu.applicationOptions.sections).forEach(key => sectionOptions = sectionOptions.concat(MainMenu.applicationOptions.sections[key].options));
                    return sectionOptions.find(item =>  item.displayType === displayType);
            }

        }


          function getMenu() {

            if (!$rootScope.globals.currentUser) {
                $rootScope.showMainView = false;
                $scope.userInfo = {};
                $scope.menu = {};
                return;
            }

            if($scope.appsLoading || !$rootScope.globals.application) {
                return;
            }

            $scope.appsLoading = true;

            MainMenu.GetMenu($rootScope.globals.application.id).then(function (menu) {
                $scope.menu = menu;
                $timeout(function () {
                    initMenu();
                    $rootScope.showMainView = true;
                    $scope.appsLoading = false;
                    $scope.menuLoaded = true;
                }, 100);
            });
        }

          function initMobileTitle() {
              var path = $location.path();

              $scope.isHomePage = path === '/home';
              $scope.isTodayAssignments = path.indexOf('todaysAssignments') !== -1;
          }
          

         // Left Menu Animation

          $(window).on("resize", function () {
              if ($(window).width() < 1250 && !doNotChangeOnResize) {
                  if ($('.navbar-collapse').hasClass('in')) {
                      $('.navbar-collapse').removeClass('in');
                  }

                  if ($('#page-content').hasClass('out')) {
                      $('#page-content').removeClass('out');
                  }
              }
          });

          function initMenu() {
              var applicationOption = getApplicationOption();
              BrowserTab.Tab.tabName = applicationOption && applicationOption.tabName ? applicationOption.tabName : Constants.TabNames.Default;

              if ($(window).width() < 1250 || (applicationOption ? applicationOption.hideMenuFlag : false)) {
                  MainMenu.HideMenu();
              } else {
                  MainMenu.ShowMenu();
              }

              setTimeout(function () {
                  $rootScope.$broadcast('resizeGridEvent');
              }, 500);
          }

          function init() {
            $scope.token = TokenInterceptor._token;
            UserInfo.GetUserInfo().then(function (user) {
                $scope.userInfo = user;
                getMenu();

                $window.pendo.initialize(getPendoMetadata());
            });
          }

          if ($rootScope.globals.currentUser) {
              init();
          }

          $rootScope.$on('logedIn', init);
          $rootScope.$on('changingApp', changeApplication);
          $rootScope.$on('changingSite', switchSite);
          $rootScope.$on('changingRole', switchRole);
          $rootScope.$on('changingPIGroup', switchGroup);

          $rootScope.$on('$routeChangeSuccess', function () {
              initMobileTitle();
              initMenu();
              getMenu();
          });

          getMenu();
      }
  ]);